import { SelfInitiatedProfileForm } from '@/features/setup/components/SelfInitiatedProfileForm';
import { AdminInitiatedProfileForm } from '@/features/setup/components/AdminInitiatedProfileForm';
import { useUser } from '@/lib/auth';
import { useSearchParams } from 'react-router-dom';
import { PRIVATE_TOP_PATH } from '@/routes/private';
import { AuthUser } from '@/features/auth';
import { ProfileFormProps } from '@/features/setup/types';
import { ComponentType } from 'react';

type SignupInitiation = AuthUser['signupInitiation'];

const PROFILE_FORMS: Record<
  SignupInitiation,
  ComponentType<ProfileFormProps>
> = {
  admin_initiated: AdminInitiatedProfileForm,
  self_initiated: SelfInitiatedProfileForm,
} as const;

const createRedirectUrl = (
  userType: SignupInitiation,
  redirectUrl: string | null
): string => {
  if (redirectUrl) return redirectUrl;

  const defaultPath = {
    admin_initiated: PRIVATE_TOP_PATH,
    self_initiated: '/subscription',
  }[userType];

  return new URL(defaultPath, window.location.origin).toString();
};

export const useProfileSetup = () => {
  const { data: user, isLoading } = useUser();
  const [searchParams] = useSearchParams();
  const redirectUrl = searchParams.get('to');

  const getFormProps = (userType: SignupInitiation) => {
    return {
      redirectUrlOnSuccess: createRedirectUrl(userType, redirectUrl),
    };
  };

  const getFormComponent = (userType: SignupInitiation) => {
    return PROFILE_FORMS[userType];
  };

  return {
    user,
    isLoading,
    getFormProps,
    getFormComponent,
  };
};
